import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/phone.svg';
import _imports_1 from '@/assets/image/mail.svg';
import _imports_2 from '@/assets/image/password.svg';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-ce79b4d4"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "infoBox"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-jiantou-you"
  }, null, -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }, null, -1);
});
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-jiantou-you"
  }, null, -1);
});
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }, null, -1);
});
var _hoisted_7 = {
  key: 0
};
var _hoisted_8 = {
  key: 1
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-jiantou-you"
  }, null, -1);
});
var _hoisted_10 = ["src"];
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-jiantou-you"
  }, null, -1);
});
import info from '@/api/info';
import { useLang } from '@/hooks/lang';
import { ref } from 'vue';
import { VueCookieNext } from 'vue-cookie-next';
import { useStore } from 'vuex';
import confirmDialog from './infoDialog/confirm-dialog.vue';
import mailDialog from './infoDialog/mail.vue';
import passwordDialog from './infoDialog/password.vue';
import phoneDialog from './infoDialog/phone.vue';
export default {
  setup: function setup(__props) {
    var $store = useStore();
    var _get = require('lodash/get');
    var _useLang = useLang('@shining3d/app'),
      $t = _useLang.$t;
    var mailDialogRef = ref(null);
    var confirmDialogRef = ref(null);
    var passwordDialogRef = ref(null);
    var phoneDialogRef = ref(null);
    var authInfo = ref({});
    var hasPwd = ref($store.state.userInfo.hasPwd);
    var countryCode = VueCookieNext.getCookie('cc') === 'CN' ? 'wechat' : 'google';
    var getBindOauth = function getBindOauth() {
      info.getBindOauth(countryCode).then(function (res) {
        authInfo.value = _get(res, 'result');
        console.log(authInfo);
      }).catch(function () {
        authInfo.value = {};
      });
    };
    getBindOauth();
    var dialogChange = function dialogChange(val) {
      val.dialogVisible = true;
    };
    return function (_ctx, _cache) {
      var _component_el_row = _resolveComponent("el-row");
      var _component_el_col = _resolveComponent("el-col");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
        class: "title"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_unref($t)('personalInformation.passWord.title')), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "listInfo"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            class: "image"
          }, {
            default: _withCtx(function () {
              return [_hoisted_2];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            class: "info"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", null, _toDisplayString(_unref($t)('personalInformation.passWord.phone')), 1), _createElementVNode("div", null, _toDisplayString(_unref(_get)(_unref($store), 'state.userInfo.phone', '-') || '-'), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            class: "edit",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return dialogChange(phoneDialogRef.value);
            })
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref(_get)(_unref($store), 'state.userInfo.phone') ? _unref($t)('personalInformation.passWord.unReplaceBinding') : _unref($t)('personalInformation.passWord.goBinding')) + " ", 1), _hoisted_3];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "listInfo"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            class: "image"
          }, {
            default: _withCtx(function () {
              return [_hoisted_4];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            class: "info"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", null, _toDisplayString(_unref($t)('personalInformation.passWord.mail')), 1), _createElementVNode("div", null, _toDisplayString(_unref(_get)(_unref($store), 'state.userInfo.email', '-') || '-'), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            class: "edit",
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return dialogChange(mailDialogRef.value);
            })
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref(_get)(_unref($store), 'state.userInfo.email') ? _unref($t)('personalInformation.passWord.unReplaceBinding') : _unref($t)('personalInformation.passWord.goBinding')) + " ", 1), _hoisted_5];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "listInfo"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            class: "image"
          }, {
            default: _withCtx(function () {
              return [_hoisted_6];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            class: "info"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", null, _toDisplayString(_unref($t)('personalInformation.passWord.passWord')), 1), hasPwd.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref($t)('personalInformation.passWord.set')), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref($t)('personalInformation.passWord.unset')), 1))];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            class: "edit",
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return dialogChange(passwordDialogRef.value);
            })
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref($t)('personalInformation.passWord.edit')) + " ", 1), _hoisted_9];
            }),
            _: 1
          })];
        }),
        _: 1
      }), authInfo.value.openId ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0,
        class: "title"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_unref($t)('personalInformation.passWord.thirdParty')), 1)];
        }),
        _: 1
      })) : _createCommentVNode("", true), authInfo.value.openId ? (_openBlock(), _createBlock(_component_el_row, {
        key: 1,
        class: "listInfo"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            class: "image"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("img", {
                src: _unref(countryCode) === 'wechat' ? require('@/assets/image/wx.svg') : require('@/assets/image/google.svg'),
                alt: ""
              }, null, 8, _hoisted_10)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            class: "info"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", null, _toDisplayString(_unref($t)(_unref(countryCode) === 'wechat' ? 'personalInformation.passWord.wx' : 'personalInformation.passWord.google')), 1), _createElementVNode("div", null, _toDisplayString(authInfo.value.nickName), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            class: "edit",
            onClick: _cache[3] || (_cache[3] = function ($event) {
              return dialogChange(confirmDialogRef.value);
            })
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref($t)('personalInformation.passWord.unBinding')) + " ", 1), _hoisted_11];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(mailDialog, {
        ref_key: "mailDialogRef",
        ref: mailDialogRef
      }, null, 512), _createVNode(passwordDialog, {
        ref_key: "passwordDialogRef",
        ref: passwordDialogRef
      }, null, 512), _createVNode(phoneDialog, {
        ref_key: "phoneDialogRef",
        ref: phoneDialogRef
      }, null, 512), _createVNode(confirmDialog, {
        ref_key: "confirmDialogRef",
        ref: confirmDialogRef,
        onSuccessOut: _cache[4] || (_cache[4] = function ($event) {
          return getBindOauth();
        }),
        typeConfirm: _unref(countryCode),
        openId: authInfo.value.openId || ''
      }, null, 8, ["typeConfirm", "openId"])]);
    };
  }
};